import * as React from "react";

import { api } from "@repo/backend";
import { Outlet, createFileRoute, useRouterState, useSearch } from "@tanstack/react-router";
import { useQuery } from "convex/react";

import { type ScheduleInfo, SchedulingLayout } from "@/components/scheduling/scheduling-layout";
import { sessionTypeSchema } from "@/lib/scheduling";

export const Route = createFileRoute("/scheduling")({
  component: SchedulingRoute,
});

function SchedulingRoute() {
  const search = useSearch({ strict: false });
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const type = sessionTypeSchema.safeParse(search.type);
  const token = pathname.match(/^\/scheduling\/confirmed\/([^/]+)$/)?.[1];
  const schedule = useQuery(
    api.scheduling.getPublicSchedule,
    type.success ? { type: type.data } : "skip",
  );
  const confirmation = useQuery(api.scheduling.getBookingConfirmation, token ? { token } : "skip");
  const configRef = React.useRef<ScheduleInfo>(undefined);
  const config = schedule?.config ?? confirmation?.config;
  if (config) configRef.current = config as ScheduleInfo;

  return (
    <SchedulingLayout config={type.success || token ? configRef.current : undefined}>
      <Outlet />
    </SchedulingLayout>
  );
}
